import axios from 'axios'
import Qs from 'qs'
import app from '../main';


// 环境的切换
//当前协议
let api = `${window.location.protocol}//${process.env.API_HOST}`
if (!api){
    if (process.env.NODE_ENV === 'production') {
        api = `${window.location.protocol}//zmapi.yuansiwei.com`
    }else {
        api = `${window.location.protocol}//192.168.1.42:8089`
    }
}
axios.defaults.baseURL = api

// 请求超时时间
axios.defaults.timeout = 60000

// header携带cookie
axios.defaults.withCredentials = true
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

// 请求拦截器
axios.interceptors.request.use(
	config => {
		let url = config.url
		config.headers = { 'Content-Type' : 'application/x-www-form-urlencoded','token': localStorage.getItem('token')}
		return config
	},
	error => {
		return Promise.error(error)
	}
)

// 响应拦截器
axios.interceptors.response.use(
	response => {
		// hideLoading()
		if (response.status === 200) {
			return Promise.resolve(response)
		} else {
			return Promise.reject(response)
		}
	},
	// 服务器状态码不是200的情况
	error => {
		if (error.response.status) {
			switch (error.response.status) {
				case 400:

					error.message = '错误请求'

					break
				// 401: 未登录
                case 401:
					localStorage.removeItem('token')
					var second = 3;
					var timer = setInterval(() => {
						second--;
						if (second <= 0) {
							clearInterval(timer);
							if(app.$route.name !== 'Login'){
								app.$router.push({name:'Login'})
							}
						}
					}, 1000);
					return
				// 其他错误，直接抛出错误提示
				case 403:

					error.message = '拒绝访问'

					break

				case 404:

					error.message = '请求错误,未找到该资源'

					break

				case 405:

					error.message = '请求方法未允许'

					break

				case 408:

					error.message = '请求超时'

					break

				case 500:

					error.message = '服务器端出错'

					break

				case 501:

					error.message = '网络未实现'

					break

				case 502:

					error.message = '网络错误'

					break

				case 503:

					error.message = '服务不可用'

					break

				case 504:

					error.message = '网络超时'

					break

				case 505:

					error.message = 'http版本不支持该请求'

					break

				default:

					error.message = `连接错误${error.response.status}`

				// console.log(error.response.data.message)
			}

            console.log('请求 error : ',error.message)
			// Message.error({
			// 	message: error.message
			// })
			return Promise.reject(error.response)
		}
	}
)


/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get (url, params) {
	return new Promise((resolve, reject) => {
		axios.get(url, {
				params: params
			})
			.then(res => {
				resolve(res.data)
			})
			.catch(err => {
				reject(err.data)
			})
	})
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post (url, params) {
	return new Promise((resolve, reject) => {
		axios.post(url, Qs.stringify(params))
			.then(res => {
				resolve(res.data)
			})
			.catch(err => {
				reject(err.data)
			})
	})
}



// WEBPACK FOOTER //
// ./src/router/http.js